import React, { useEffect } from "react";
import { Field, InputContainer, Label, ValidateHelp } from "./styles";

type SelectProps = {
  label: string;
  placeholder?: string;
  value?: string | number;
  name?: string;
  hasError?: boolean;
  error?: string;
  register: any;
  required: any;
  options: any;
  onChange?: any;
  disabled?: boolean
};

const Select: React.FC<SelectProps> = ({
  label,
  placeholder,
  value,
  name,
  hasError,
  error,
  register,
  required,
  options,
  disabled = false
}) => {
  const [messageError, setMessageError] = React.useState("");

  useEffect(() => {
    if (hasError && error) {
      setMessageError(error);
    } else {
      setMessageError("");
    }
  }, [hasError, error]);

  return (
    <InputContainer>
      <Label>{label}</Label>
      <Field
        hasError={hasError && error}
        value={value}
        placeholder={placeholder}
        {...register(name, { required })}
        disabled={disabled}
      >
        {options &&
          options.map((option: any, key: any) => (
            <option key={key} value={option.option}>
              {!Number.isNaN(option.tile) ? option.title : 0}
            </option>
          ))}
      </Field>
      <ValidateHelp>{messageError || ""}</ValidateHelp>
    </InputContainer>
  );
};

export default Select;
